<template>
  <section id="services" class="padding-x mb-20">
    <div class="flex w-full flex-col">
      <div id="what-i-do" class="w-full max-w-[800px]">
        <svg
          width="100%"
          height="100%"
          viewBox="0 0 600 80"
          preserveAspectRatio="xMinYMid meet"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="textGradient-services" x1="0%" y1="0%" x2="100%" y2="0%">
              <stop offset="0%" stop-color="#CE2906" />
              <stop offset="33%" stop-color="#E04A20" />
              <stop offset="66%" stop-color="#E65820" />
              <stop offset="100%" stop-color="#FF7B00" />
            </linearGradient>
          </defs>
          <text
            x="0"
            y="50"
            font-size="50"
            font-family="Inter, Arial, sans-serif"
            font-weight="560"
            letter-spacing="0"
            fill="url(#textGradient-services)"
            textLength="400"
            lengthAdjust="spacingAndGlyphs"
            class="uppercase"
          >
            WHAT WE DO /
          </text>
        </svg>
      </div>

      <div
        id="services-text"
        class="grid-gap text-flax-smoke-300 mt-[5%] grid grid-cols-12 justify-end opacity-0 lg:grid"
      >
        <p
          class="heading-6 text-flax-smoke-300/85 col-span-4 col-start-0 text-center text-nowrap md:col-start-4 text-gradient-draftex"
        >
          ( SKILLS )
        </p>
        <p
          class="heading-4 font-fancy col-span-8 w-full text-balance sm:font-semibold md:col-span-5"
        >
          We turn ideas into visually powerful and high-performing digital solutions.Our work spans design, development, marketing, and content—crafted for real impact.At DRAFTEX, we combine creativity, strategy, and AI to help brands grow faster.
        </p>
      </div>
    </div>

    <div class="relative mt-12 w-full lg:mt-[10%]">
      <div class="mt-12 flex flex-col justify-between gap-y-16">
        <ServicesCard
          v-for="(card, index) in servicesCardProps"
          :key="index"
          :number="index + 1"
          :title="card.title"
          :body="card.body"
          :headings="card.headings"
          :shape="card.shape"
          class="border-flax-smoke-500/50 sticky border-t bg-[#0B0B0A]"
          :class="getStyle(index)"
        />
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { animateSplitText } from '@/animations';
  import { textSplitterIntoChar } from '@/functions';
  import { onBeforeMount, onMounted, ref } from 'vue';
  import { ServicesCard } from '..';

  const whatIDo = ref('My services /');

const servicesCardProps = [
  {
    title: 'Graphic Design',
    body: 'We create visually compelling designs that bring your brand to life.From logos to marketing materials, every design is crafted for impact and clarity.DRAFTEX blends creativity and strategy to make your brand stand out.',
    headings: [
      'Brand Identity & Logo Design',
      'Marketing & Promotional Creatives',
      'Social Media & Visual Content',
    ],
    shape: `<svg viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0C103.395 53.7596 146.24 96.6052 200 100C146.24 103.395 103.395 146.24 100 200C96.6052 146.24 53.7596 103.395 0 100C53.7596 96.6052 96.6052 53.7596 100 0Z"/>
  </svg>`,
  },
  {
    title: 'UI/UX Design',
    body: 'Clean, user-first interfaces that actually feel good to use.We design smooth, modern digital experiences that keep users engaged.Built with strategy, tested for usability, and optimized for real impact.',
    headings: [
      'UI Design for Web & Apps',
      'Website Redesign & Revamp',
      '⁠Landing Page Design for Conversions',
    ],
    shape: `<svg viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
  <path d="M127.14 200C99.9942 200 99.9943 167.423 72.8487 167.423C41.6048 167.423 0 158.386 0 127.133C0 99.9885 32.5678 99.9885 32.5678 72.8445C32.5678 41.6139 41.6048 0 72.8602 0C100.006 0 100.006 32.5774 127.151 32.5774C158.384 32.5774 200 41.6139 200 72.8675C200 100.012 167.421 100.012 167.421 127.156C167.409 158.444 158.384 200 127.14 200Z" />
  </svg>`,
  },
  {
    title: 'Digital Marketing',
    body: 'Growth-focused digital marketing that drives real results, not just reach. We build smart strategies that connect your brand with the right audience. Powered by data, creaivity, and performance-driven execution.',
    headings: [
      'Social Media & Performance Marketing',
      'SEO & Content Strategy',
      'Ads, Analytics & Growth Optimization',
    ],
    shape: `<svg  viewBox="0 0 200 200"  xmlns="http://www.w3.org/2000/svg">
  <path d="M100 0L170.711 29.2893L200 100L170.711 170.711L100 200L29.2893 170.711L0 100L29.2893 29.2893L100 0Z" />
  </svg>`,
  },
];


  onBeforeMount(() => {
    whatIDo.value = textSplitterIntoChar('What We do ', true);
  });

  onMounted(() => {
    animateSplitText('#what-i-do .letters', '#services-text', 0.7, 0.01, 0);
  });

  const getStyle = (index: number) => {
    if (index === 0) {
      return 'top-[calc(20vh_+_0em)] mb-20 md:mb-[17.25em]';
    }

    if (index === 1) {
      return 'top-[calc(20vh_+_5.75em)] mb-10 md:mb-[11.5em]';
    }

    if (index === 2) {
      return 'top-[calc(20vh_+_11.5em)] mb-4 md:mb-[5.75em]';
    }
  };
</script>
